/**
 * The side a native call is placed on (docs/regional-queue-routing.md): one of
 * the regions an admin granted this account — United States & Canada or the
 * Gulf — for accounts granted more than one (the CEO). Not the country of the
 * number dialled. Same rule as the web client (shared/service-regions.js).
 *
 * The pick is saved per account in `vrs_service_region` and re-checked against
 * the account's current grants on every read, so a revoked region, or another
 * account's pick on a shared device, is ignored.
 */
import { SERVICE_REGIONS, grantedRegions, selectServiceRegion, serviceRegion } from '../../../../shared/service-regions';
import { getWhitelabelConfig } from '../../base/whitelabel/functions';
import { getPersistentJson, setPersistentItem } from '../../vrs-auth/storage';
export const SERVICE_REGION_STORAGE_KEY = 'vrs_service_region';
/** Regions this account may choose between; a picker is shown only for two or more. */
export function serviceRegionChoices(account) {
    return grantedRegions(account?.serviceRegions)
        .map(id => ({ value: id, label: SERVICE_REGIONS[id].label }));
}
/** The region the next request is placed in, or null for an undesignated account (the server decides). */
export function selectedServiceRegion(account) {
    const saved = getPersistentJson(SERVICE_REGION_STORAGE_KEY);
    const ownPick = saved && account?.id && saved.owner === account.id ? saved.region : null;
    return selectServiceRegion(account?.serviceRegions, ownPick, serviceRegion(getWhitelabelConfig()?.operations).id);
}
/** The region for the signed-in account (vrs_user_info), for screens without a profile hook. */
export function currentServiceRegion() {
    return selectedServiceRegion(getPersistentJson('vrs_user_info'));
}
/** Remember a pick for this account; refused unless the account is granted that region. */
export function saveServiceRegion(account, region) {
    if (!account?.id || !serviceRegionChoices(account).some(choice => choice.value === region)) {
        return false;
    }
    setPersistentItem(SERVICE_REGION_STORAGE_KEY, JSON.stringify({ owner: account.id, region }));
    return true;
}
